export default __webpack_public_path__ + "media/images/portfolio/gallery-08-1200x801_original-516f9047eb7c5ada56aef1c450156524.jpg";